'use strict';

const baseSubmit = require('richemont/experience/components/newsletterComponent');
const $document = $(document);

$document.ready(function () {
    if (window.recaptchaSiteKey) {
        $document.on('submit', '.newsletter-form', function (e) {
            const $form = $(this);
            let ready = $form.find('input[name=recaptcharesponse]').length > 0;
            if (ready) {
                return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();

            // Check if Google reCaptcha is enabled, and check for the token.
            grecaptcha.ready(function () {
                grecaptcha.execute(window.recaptchaSiteKey, { action: 'submit' }).then((token) => {
                    if (token) {
                        $('<input>').attr('type', 'hidden').attr('name', 'recaptcharesponse').attr('value', token).appendTo($form);
                        ready = true;
                        $form.submit();
                        $form.find('input[name=recaptcharesponse]').remove();
                    } else {
                        window.location.href = window.errorRedirectURL;
                    }
                });
            });
        });

        baseSubmit.newsletterSubmit();
    }
});
